<template>
  <!--我的销量页面-->
  <tk-container
    disable-scroll
  >
    <!--头部-->
    <my-header slot="header">我的销量</my-header>
    <!--tab切换-->
    <tkui-tab around style="height: 100%;">
      <tkui-tab-item label="年度销量">
        <factory-container v-if="isFactoryAccount" :sales-type="'year'" :bg-image="yearImage"></factory-container>
        <sales-container v-else :sales-type="'year'" :bg-image="yearImage"></sales-container>
      </tkui-tab-item>
      <tkui-tab-item label="月度销量">
        <factory-container v-if="isFactoryAccount" :sales-type="'month'" :bg-image="monthImage"></factory-container>
        <sales-container v-else :sales-type="'month'" :bg-image="monthImage"></sales-container>
      </tkui-tab-item>
    </tkui-tab>
  </tk-container>
</template>

<script>
import salesContainer from '@/components/salesContainer'
import factoryContainer from '@/components/factoryContainer'
let yearImage = 'https://s3.moke.cloud/dianpei/56fdb70d-6547-46bf-a6e4-b4c5f011cddc.png'
let monthImage = 'https://s3.moke.cloud/dianpei/67fb51a4-5280-4f98-aeb6-2d5eacf0edb7.png'
export default {
  components: {
    salesContainer,
    factoryContainer
  },
  data () {
    return {
      yearImage: yearImage, // 年销量图片
      monthImage: monthImage // 月销量图片
    }
  },
  mounted () {
    this.setStatusBar('dark')
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  }
}
</script>

<style scoped lang="scss">
  /*tab样式*/
  ::v-deep .tkui-tab .tabs-wrap {
    background-color: #fff;
    height: 45px !important;
    border-bottom: 0 solid #f5f5f5;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item {
    color: rgba(157, 153, 156, 1);
    font-size: 16px;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item.active {
    color: #000000 !important;
    font-weight: bold !important;
    font-size: 16px;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item.active:before {
    background: #000000;
    width: 30% !important;
    height: 3px !important;
    left: 40% !important;
  }
</style>
